<app-back-header
  [headerText]="'Torna alla dashboard'"
  (backAction)="backToDashboard()"
  class="sticky-top">
</app-back-header>

<div class="d-flex justify-content-between align-items-center mb-2">
  <h3 class="ms-2 mt-2">Guide e tutorial</h3>
</div>

<p class="ms-2">In questa pagina trovi tutorial e consigli per usare l'App di {{ sourceLabels[organization_data?.source || ''] || 'fatturazione' }} nel migliore dei modi.</p>

<ng-container *ngIf="isLoading">
  <div class="loading-container d-flex flex-column justify-content-center align-items-center py-5">
    <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
    <p class="mt-3">Caricamento in corso...</p>
  </div>
</ng-container>

<div *ngIf="!isLoading" class="guides-grid">
  <div class="row g-3">

    <div class="col-12 col-md-6 col-lg-4" *ngFor="let guide of tutorials">

      <!-- Card guida: superficie piatta bianca con bordo nero 2px e angolo
           basso-sinistra vivo, come le card del resto dell'app (utility
           globali .custom-card-border / .izy-sharp-bl in styles.scss).
           Prima erano card grigie di Material con una barretta petrol che
           cambiava lato fra mobile e desktop. -->
      <mat-card
        class="h-100 guide-card izy-sharp-bl custom-card-border"
        (click)="handleGuideClick(guide.id)">

        <mat-card-header class="guide-header">
          <!-- Tessera petrol con l'icona della guida: stessa superficie scura
               piena delle altre tessere del linguaggio BEIZY, angolo vivo
               incluso, con il raggio ridotto alla misura del riquadro. -->
          <div class="guide-badge izy-sharp-bl" style="--izy-radius: 10px">
            <mat-icon>{{ guide.icon }}</mat-icon>
          </div>

          <div class="guide-heading">
            <!-- Il numero era incollato al titolo ("1 - Primi passi"): qui
                 diventa una sopralinea, cosi' il titolo si legge da solo. -->
            <span class="guide-eyebrow">Guida {{ guide.id }}</span>
            <mat-card-title class="guide-title">{{ guide.title }}</mat-card-title>
          </div>
        </mat-card-header>

        <mat-card-content class="guide-content">
          <p class="guide-subtitle">{{ guide.subtitle }}</p>
          <p class="guide-text mb-0">{{ guide.content }}</p>
        </mat-card-content>

        <!-- Footer su fondo panna separato dal tratto nero 2px, come il footer
             delle card fattura/cliente. Con il content in flex-grow resta
             allineato in fondo su tutte le card della riga. -->
        <div class="d-flex justify-content-end align-items-center guide-card-footer">
          <button
            mat-stroked-button
            class="me-2 guide-open-btn custom-button-border"
            (click)="handleGuideClick(guide.id); $event.stopPropagation()"
            [attr.aria-label]="'Apri la scheda della guida ' + guide.title">
            <div class="d-flex justify-content-between align-items-center">
              <p class="mb-0">Apri scheda</p>
              <span>
                <mat-icon class="ms-2 m-0">chevron_right</mat-icon>
              </span>
            </div>
          </button>
        </div>

      </mat-card>

    </div>

  </div>
</div>

<div class="pt-4 mb-3"></div>
